import styles from '../../../sass/apricot.module.scss';
export default (function (_ref) {
  var message = _ref.message,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'gray' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'lg' : _ref$size,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? styles.loader : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    "aria-live": "polite",
    role: "progressbar",
    "aria-valuetext": "Loading...",
    className: "".concat(className, " cb-loader-").concat(color, " cb-loader cb-loader-").concat(size)
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, message || 'Loading...'));
});